const sortByFullName = (a, b, dir) => {
  a = a.props.student.fullName.toLowerCase().replace(/\s/g, '')
  b = b.props.student.fullName.toLowerCase().replace(/\s/g, '')

  if (a > b) return dir === 'desc' ? -1 : 1
  if (a < b) return dir === 'desc' ? 1 : -1
  return 0
}

const sortByCoach = (a, b, dir) => {
  const coach1 = a.props.student.coaches[0]?.name || ''
  const coach2 = b.props.student.coaches[0]?.name || ''
  a = coach1.toLowerCase().replace(/\s/g, '')
  b = coach2.toLowerCase().replace(/\s/g, '')

  if (a > b) return dir === 'desc' ? -1 : 1
  if (a < b) return dir === 'desc' ? 1 : -1
  return 0
}
const sortByAgeGroup = (a, b, dir) => {
  const ageRank = student => (student.isMinor ? 0 : 1)
  const aVal = ageRank(a.props.student)
  const bVal = ageRank(b.props.student)

  if (aVal < bVal) return dir === 'desc' ? 1 : -1
  if (aVal > bVal) return dir === 'desc' ? -1 : 1
  return 0
}

const sortByUpcoming = (a, b, dir) => {
  a = a.props.student.upcomingSession?.startDateTime
  b = b.props.student.upcomingSession?.startDateTime

  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  if (a < b) return dir === 'desc' ? 1 : -1
  if (a > b) return dir === 'desc' ? -1 : 1
  return 0
}

export { sortByUpcoming, sortByFullName, sortByCoach, sortByAgeGroup }
